<template>
    <div class="offer-box"
        v-if="getOfferText.length > 10">
        <a href="javascript:void(0);"
            data-toggle="popover"
            title="Sonderangebote"
            data-trigger="click"
            data-placement="top"
            data-html="true"
            :data-content="getOfferText">
            <span class="offer-left">Sonderangebote verfügbar</span>
        </a>
    </div>

</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    import {
    	getVoucher
    }
    from 'voUtils/VoucherStore.js';

    export default {
    	voVueComponent: 'offer-help',
    	props: {
    		offers: Array
    	},
    	methods: {
    		getVoucherCode: function() {
    			var voucher = getVoucher();
    			//console.log("getvoucher==>" + getVoucher());
    			if (voucher) {
    				return voucher.code;
    			}
    			return null;
    		},

    	},
    	mounted: function() {
    		$('[data-toggle="tooltip"]').tooltip();
    		$('[data-toggle="popover"]').popover();
    		$('body').on('click', function(e) {
    			$('[data-toggle=popover]').each(function() {
    				if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
    					(($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false;
    				}
    			});
    		});
    	},
    	computed: {

    		getOfferText: function() {
    			//console.log('inside getOfferText');
    			var offerText = '';
    			if (this.offers) {
    				//console.log('inside condition' + this.offers.length);
    				this.offers.sort((a, b) => (a.fromdate > b.fromdate) ? 1 : -1);
    				var i;
    				offerText = "<ul>";
    				for (i = 0; i < this.offers.length; i++) {
    					//console.log('inside offer loop');
    					var offer = this.offers[i];
    					//console.log('voucher code is==>' + offer.voucherCode + '-----' + this.getVoucherCode());
    					if (!offer.voucherCode || offer.voucherCode === this.getVoucherCode()) {
    						//console.log('inside voucher code condition');
    						var offer = this.offers[i];

    						offerText += "<li>";

    						offerText += offer.name + " ";
    						if (offer.discountType === 'PERCENT') {
    							offerText += "- " + offer.value / 100 + "% Rabatt ";
    						}

    						if (offer.type === 'EARLYBIRD') {
    							if (offer.timeSpan === 1) {
    								offerText += "bei Anreise in frühestens einem Tag ";
    							} else if (offer.timeSpan > 1) {
    								offerText += "bei Anreise in frühestens " + offer.timeSpan + "Tagen ";
    							}

    						}

    						if (offer.type === 'LASTMINUTE') {
    							if (offer.timeSpan == 1) {
    								offerText += "bei Anreise in spätestens einem Tag ";
    							} else if (offer.timeSpan > 1) {
    								offerText += "bei Anreise in spätestens " + offer.timeSpan + "Tagen ";
    							}

    						}


    						if (offer.fromdate) {
    							offerText += "vom " + DateEx.formatDate(this.offers[i].fromdate, undefined, VOFFICE.mlang) + " ";
    						}
    						if (offer.tilldate) {
    							offerText += "bis " + DateEx.formatDate(this.offers[i].tilldate, undefined, VOFFICE.mlang) + " ";
    						}

    						if (offer.minStay > 1) {
    							offerText += "(min. " + offer.minStay + " ÜN)";
    						}

    						offerText += "</li>";
    					}
    				}
    			}
    			//console.log('offer text is==>' + offerText);
    			return offerText;
    		}
    	}
    };
</script>